import { useConfigStore } from '@/store/config.store';
import { useAnimationControl } from '@/composables/useAnimationControl';
import { storeToRefs } from 'pinia';
import type { EAppStep } from '@/typescript/enums/EAppStep';

function useStepper() {
    const { currentStep } = storeToRefs(useConfigStore());
    const { stopAnimation } = useAnimationControl();

    function goToStep(step: EAppStep) {
        stopAnimation();
        currentStep.value = step;
    }
    return { goToStep, currentStep };
}

export { useStepper };
